import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RolesEnum } from './service/enums/role.enum';
import { BaseComponent } from './shared/components/base.component';
import { MessagingService } from './shared/messaging.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends BaseComponent implements OnInit {
  title = 'demo1';

  showSidebar: boolean = true;
  showNavbar: boolean = true;
  showPublicHeader: boolean = false;
  showFooter: boolean = true;
  showPublicFooter: boolean = false;
  showSettings: boolean = false;
  isLoading: boolean;
  isCustomer: boolean = true;
  constructor(translate: TranslateService,
    private messagingService: MessagingService) {
    super();

    var userProfile = this.userProfileService.getProfile();
    if (userProfile && userProfile !== null && userProfile.isLoggedIn === true && !this.userProfileService.isOnlyRoleExists(RolesEnum.Customer)) {
      this.isCustomer = false;
    } else {
      this.isCustomer = true
    }
    var lang = localStorage.getItem("lang");
    //get default language from browser;
    if (!lang || lang === null || lang === "")
      lang = navigator.language.substr(0, 2);

    translate.setDefaultLang("en");
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use(lang);

    if (lang === "ar") {
      document.querySelector('body').classList.add('rtl');
      $('#mainStyle').attr('href', 'assets/css/custom-ar.css');
    } else {
      document.querySelector('body').classList.remove('rtl');
      $('#mainStyle').attr('href', 'assets/css/custom.css');
    }

    // if (this.userprofile.isLoggedIn === true && this.userprofile.id != null && this.userprofile.id != 0) {
    //   var token = localStorage.getItem("NotificationToken");
    //   //if (!token || token === null || token === "") {
    //   this.messagingService.requestPermission(this.userprofile.id);
    //   // }
    // }

    // Removing Sidebar, Navbar, Footer for Documentation, Error and Auth pages

    this.router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        var userProfile = this.userProfileService.getProfile();
        if (userProfile && userProfile !== null && userProfile.isLoggedIn === true && !this.userProfileService.isOnlyRoleExists(RolesEnum.Customer)) {
          this.isCustomer = false;
        } else {
          this.isCustomer = true
        }
        this.adjustView(event);
      }
    });

    // Spinner for lazyload modules
    this.router.events.forEach((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.isLoading = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.isLoading = false;
      }
    });
  }


  adjustView(event) {
    if (
      (event['url'].startsWith('/account/login')) ||
      (event['url'].startsWith('/account/resetPassword')) ||
      (event['url'].startsWith('/customer/paymentResponse')) ||
      (event['url'].startsWith('/error/')) ||
      (event['url'] == '/account/forgotPassword') ||
      (event['url'] == '/account/login-2') ||
      (event['url'] == '/account/register') ||
      (event['url'] == '/account/register-2') ||
      (event['url'] == '/account/lock-screen' ||
        this.isCustomer === true)) {
      this.showSidebar = false;
      this.showNavbar = false;
      this.showFooter = false;
      this.showSettings = false;
      this.showPublicFooter = true;
      this.showPublicHeader = true;
      document.querySelector('.main-panel').classList.add('w-100');
      document.querySelector('.page-body-wrapper').classList.add('full-page-wrapper');
      if ((event['url'] == '/account/login-2') || (event['url'] == '/account/register-2')) {
        document.querySelector('.content-wrapper').classList.add('auth', 'auth-img-bg',);
      } else if (event['url'] == '/account/lock-screen') {
        document.querySelector('.content-wrapper').classList.add('auth', 'lock-full-bg');
      } else {
        document.querySelector('.content-wrapper').classList.remove('auth', 'auth-img-bg',);
        document.querySelector('.content-wrapper').classList.remove('auth', 'lock-full-bg');
      }
      if ((event['url'] == '/error-pages/404') || (event['url'] == '/error-pages/500')) {
        document.querySelector('.content-wrapper').classList.add('p-0');
      }
    } else {
      this.showSidebar = true;
      this.showNavbar = true;
      this.showFooter = true;
      this.showSettings = false;
      this.showPublicFooter = false;
      this.showPublicHeader = false;
      document.querySelector('.main-panel').classList.remove('w-100');
      document.querySelector('.page-body-wrapper').classList.remove('full-page-wrapper');
      document.querySelector('.content-wrapper').classList.remove('auth', 'auth-img-bg');
      document.querySelector('.content-wrapper').classList.remove('p-0');
    }
  }

  ngOnInit() {

    // Scroll to top after route change
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);

      var userProfile = this.userProfileService.getProfile();
      if (userProfile && userProfile !== null && userProfile.isLoggedIn === true && !this.userProfileService.isOnlyRoleExists(RolesEnum.Customer)) {
        this.isCustomer = false;
      } else {
        this.isCustomer = true
      }
      this.adjustView(evt);

      if (userProfile.isLoggedIn === true && userProfile.id != null && userProfile.id != 0) {
        this.messagingService.requestPermission(userProfile.id);
      }

    });
  }

}
